/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ExceptionService } from '../service/exception.service';
import { ErrorWrapper } from './error-wrappers/error.wrapper';
import { ExceptionEntity } from '../exception.model';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  constructor(
    private readonly exceptionService: ExceptionService,
    @Inject(ErrorWrapper) private readonly errorWrappers: Array<ErrorWrapper>
  ) {}

  prepareAndSaveException(
    error: HttpErrorResponse | Error | any,
    systemName: any,
    createdBy: any
  ) {
    let exception: ExceptionEntity = null;
    for (const errorWrapper of this.errorWrappers) {
      if (errorWrapper.canTransform(error)) {
        exception = errorWrapper.transform(error);
      }
    }

    if (exception == null) {
      exception = new ExceptionEntity();
      exception.stackTrace = JSON.stringify(error);
    }

    exception.systemName = systemName;
    exception.createdBy = createdBy;

    this.exceptionService.saveException(exception).subscribe(() => {
      console.log('Exception saved');
    });
  }
}
